import React from 'react';
import { connect } from 'react-redux';
import StatisticsByUTMSegments from './StatisticsByUTMSegments';

const StatisticsByUTMSegmentsComponent = connect(
    function mapStateToProps(state) {
        return {
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByUTMSegments);

export default StatisticsByUTMSegmentsComponent;
